import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => (
  <footer className="bg-[#E30613] py-16" data-testid="main-footer">
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-10 px-6 md:flex-row md:justify-between">
      <div className="flex items-center gap-4">
        <div className="rounded-xl bg-white p-2 shadow-md">
          <img src="/logo-mark.png" alt="Logo 45 anni Tecnosystem" className="h-10 w-auto" />
        </div>
        <div>
          <p className="font-display text-lg font-semibold uppercase tracking-[0.15em] text-white">Tecnosystem <span className="text-white/70">45</span></p>
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/70">Open Day · 45 Anni di Innovazione</p>
        </div>
      </div>
      <div className="flex flex-col items-center gap-3 text-sm font-light text-white/85 md:flex-row md:gap-8">
        <span className="flex items-center gap-2" data-testid="footer-email"><Mail size={14} /> marketing@tecnosystem1981.com</span>
        <span className="flex items-center gap-2" data-testid="footer-phone"><Phone size={14} /> 0332 771488</span>
        <span className="flex items-center gap-2" data-testid="footer-address"><MapPin size={14} /> Via Appennini 44/C, Cocquio-Trevisago (VA)</span>
      </div>
    </div>
    <p className="mt-12 text-center text-[10px] font-bold uppercase tracking-[0.3em] text-white/60">
      © 2026 Tecnosystem SRL — Tutti i diritti riservati
    </p>
  </footer>
);

export default Footer;
